import { Controller }   from "stimulus"
import { DirectUpload } from "@rails/activestorage"

export default class extends Controller {
  static targets = ["input", "signedId", "submit", "filename", "progress", "spinner"]

  connect() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = true
  }

  pick(event) {
    if (event.target === this.inputTarget) return
    this.inputTarget.click()
  }

  handleChange() {
    const file = this.inputTarget.files[0]
    if (!file) return
    this.upload(file)
  }

  upload(file) {
    if (this.hasSubmitTarget)   this.submitTarget.disabled = true
    if (this.hasFilenameTarget) this.filenameTarget.textContent = file.name
    if (this.hasSpinnerTarget)  this.spinnerTarget.classList.remove("d-none")
    if (this.hasProgressTarget) this.progressTarget.style.width = "0%"

    const url = this.inputTarget.getAttribute("data-direct-upload-url")
    const upload = new DirectUpload(file, url, this)

    upload.create((error, blob) => {
      if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("d-none")
      if (error) {
        if (this.hasFilenameTarget) this.filenameTarget.textContent = ""
        if (this.hasSubmitTarget)   this.submitTarget.disabled = true
        flashAlert(I18n.t("quotes.import.upload_failed", { defaultValue: "Échec du téléversement." }))
        return
      }
      if (this.hasSignedIdTarget) this.signedIdTarget.value = blob.signed_id
      if (this.hasSubmitTarget)   this.submitTarget.disabled = false
      if (this.hasProgressTarget) this.progressTarget.style.width = "100%"
    })
  }

  directUploadWillStoreFileWithXHR(xhr) {
    xhr.upload.addEventListener("progress", e => {
      if (!e.lengthComputable || !this.hasProgressTarget) return
      this.progressTarget.style.width = `${Math.round((e.loaded / e.total) * 100)}%`
    })
  }
}
